import { Color, Space } from "@gocardless/flux-react";
import { Plural, Trans } from "@lingui/macro";

import { SignInApiErrors } from "../../SignIn/useSignIn";

import AlertBanner from "src/components/shared/AlertBanner";

type SignInApiErrorComponentMap = {
  [key in SignInApiErrors]?: React.ReactElement;
};

export const PasswordResetBanner = ({
  errorType,
  daysUntilRequiredPasswordReset,
}: {
  errorType: SignInApiErrors;
  daysUntilRequiredPasswordReset?: string;
}) => {
  const numberOfDays = daysUntilRequiredPasswordReset && (
    <Plural
      id="in-pluralized-day"
      value={daysUntilRequiredPasswordReset}
      one="in # day"
      other="in # days"
    />
  );

  const passwordResetBanners: SignInApiErrorComponentMap = {
    [SignInApiErrors.RequirePasswordResetForPasswordPolicy]: (
      <>
        <AlertBanner bg={Color.Sunrise_100}>
          <Trans id="force-reset-password.banner.title.force-reset-password">
            We will enforce a password reset{numberOfDays && " "}
            {numberOfDays}
          </Trans>
        </AlertBanner>
        <Space v={[3]} />
      </>
    ),
    [SignInApiErrors.RequirePasswordResetForResetDelayExpiry]: (
      <>
        <AlertBanner bg={Color.Alert_50}>
          <Trans id="force-reset-password.banner.title.reset-your-password">
            You must reset your password to regain access to your dashboard
          </Trans>
        </AlertBanner>
        <Space v={[3]} />
      </>
    ),
  };
  return passwordResetBanners[errorType] ?? <></>;
};

export const PasswordResetTitle = ({
  errorType,
}: {
  errorType: SignInApiErrors;
}) => {
  const passwordResetTitles: SignInApiErrorComponentMap = {
    [SignInApiErrors.RequirePasswordResetForResetDelayExpiry]: (
      <Trans id="forced-reset-password-title.delay">
        Update your password to login
      </Trans>
    ),
  };

  return (
    passwordResetTitles[errorType] ?? (
      <Trans id="forced-reset-password-title.update-password">
        Please update your password
      </Trans>
    )
  );
};
